import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import { createUseStyles, useTheme, Icon, Text, Loader } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';
const useStyles = createUseStyles(styles, 'CopilotBoxInfo');

const BoxInfo = ({ isChart, isTable, children, onDownload, loading }) => {
    const { t } = useWeb5Context();
    const classes = useStyles();
    const theme = useTheme();

    const bodyClasses = useMemo(
        () =>
            classNames(classes.body, {
                [classes.bodyChart]: isChart,
                [classes.bodyTable]: isTable,
            }),
        [classes, isChart, isTable],
    );

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <Text medium color={theme.colors.utility.textSecondary}>
                    {isChart ? t('label_report') : t('label_table')}
                </Text>
                <div className={classes.actions}>
                    <Icon className={classes.action} name="downloadAlt" onClick={onDownload} />
                </div>
            </div>
            <div className={bodyClasses}>{loading ? <Loader /> : children}</div>
        </div>
    );
};

export default memo(BoxInfo);
